import store from '../redux/store.js'; // NOVO za dispatch


/*
CHEATS

TODO:
+ globalna funkcija za ukljucenje CHEAT MODE
+ dodavanje css klasa za *** env...
+ vidljiva komponenta za cheat mode CheatsToolbar
+ action za cheats. uradjen i action creator ali za sada saljemo action object samo. 

*/

export const sastavljac_cheats_init = () => {

  //
  window.cheat = function () {
    // globalna funkcija za ukljucivanje CHEAT MODE
    console.log('**************************');
    console.log('*** CHEAT MODE ENABLED ***');
    console.log('**************************');
    const dispatch = store.dispatch;
    dispatch({ type: 'CHEATS_ENABLE' });

    // add css class
    document.documentElement.classList.add('cheats-enabled'); // html element
    document.body.classList.add('cheats-enabled', 'cheats-enabled-2'); // body
  };

};
